import Paper from "@material-ui/core/Paper";
import {
  SortingState,
  SelectionState,
  FilteringState,
  GroupingState,
  SearchState,
  IntegratedFiltering,
  IntegratedGrouping,
  IntegratedSorting,
  IntegratedSelection,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableFilterRow,
  TableSelection,
  TableGroupRow,
  GroupingPanel,
  DragDropProvider,
  TableColumnReordering,
  Toolbar,
  SearchPanel,
  TableColumnResizing,
} from "@devexpress/dx-react-grid-material-ui";
import React, { useState } from "react";
import { connect } from "react-redux";

const columns = [
  { title: "Type", name: "type" },
  { title: "User", name: "userDisplayName" },
  { title: "Property", name: "propertyDisplayName" },
  { title: "Address", name: "formattedAddress" },
  { title: "Variant", name: "variant" },
  { title: "Processed", name: "processed" },
  { title: "Time", name: "timestamp" },
  { title: "Actions", name: "actions" },
];

const Reports = ({ onSelectionChange, data, selected }) => {
  const [columnAlignment] = useState([
    { columnName: "actions", align: "right" },
  ]);
  const [filteringStateColumnExtensions] = useState([
    { columnName: "actions", filteringEnabled: false },
  ]);
  const [sortingStateColumnExtensions] = useState([
    { columnName: "actions", sortingEnabled: false },
  ]);
  const [groupingStateColumnExtensions] = useState([
    { columnName: "actions", groupingEnabled: false },
    { columnName: "timestamp", groupingEnabled: false },
  ]);
  const [defaultColumnWidths] = useState([
    { columnName: "type", width: 140 },
    { columnName: "userDisplayName", width: 150 },
    { columnName: "propertyDisplayName", width: 180 },
    { columnName: "formattedAddress", width: 240 },
    { columnName: "variant", width: 100 },
    { columnName: "processed", width: 150 },
    { columnName: "timestamp", width: 200 },
    { columnName: "actions", width: 100 },
  ]);
  return (
    <>
      <Paper>
        <Grid rows={data} columns={columns} getRowId={(row) => row.id}>
          <DragDropProvider />
          <FilteringState columnExtensions={filteringStateColumnExtensions} />
          <SearchState />
          <SortingState
            defaultSorting={[{ columnName: "timestamp", direction: "desc" }]}
            columnExtensions={sortingStateColumnExtensions}
          />
          <GroupingState columnExtensions={groupingStateColumnExtensions} />
          <SelectionState
            onSelectionChange={onSelectionChange}
            selection={selected}
          />
          <IntegratedFiltering />
          <IntegratedSorting />
          <IntegratedGrouping />
          <IntegratedSelection />
          <VirtualTable
            cellComponent={(props) => <VirtualTable.Cell {...props} />}
            columnExtensions={columnAlignment}
          />
          <TableColumnResizing defaultColumnWidths={defaultColumnWidths} />
          <TableHeaderRow showSortingControls />
          <TableColumnReordering
            defaultOrder={columns.map((column) => column.name)}
          />
          <TableFilterRow />
          <TableSelection showSelectAll />
          <TableGroupRow />
          <Toolbar />
          <SearchPanel />
          <GroupingPanel showSortingControls />
        </Grid>
      </Paper>
    </>
  );
};

const mapStateToProps = (state) => ({
  properties: state.properties.byId,
  users: state.users.byId,
});

export default connect(mapStateToProps)(Reports);
